import classes from './style.module.scss';

export const Skeleton = () => <div className={classes.shimmerDiagonal} />;
